import { render } from "./template.vue?vue&type=template&id=7bc49702&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"

import "./template.vue?vue&type=style&index=0&id=7bc49702&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc49702"]])

export default __exports__